module.exports = __webpack_public_path__ + "img/hill39.153d3be6.jpg";